import { Skeleton, Stack } from '@mui/material';

export const OfferTabLoader = () => (
  <Stack gap={2}>
    <Skeleton variant="rectangular" height={193} />
    <Skeleton variant="rectangular" height={127} />
  </Stack>
);
